import { ThemeProvider } from '@mui/material/styles';

import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { DownlineStatusProvider } from '@/contexts/DownlineStatusProvider/DownlineStatusContext';
import { AuthProvider } from '@/contexts/auth0Provider/AuthContext';
import { CountyProvider } from '@/contexts/downlineDetails/Counties';

import App from './App';
import ToastContextProvider from './components/ui/Toast/ToastContextProvider';
import customTheme from './themes/muiTheme';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider theme={customTheme}>
          <ToastContextProvider>
            <DownlineStatusProvider>
              <CountyProvider>
                <App env="standalone" />
              </CountyProvider>
            </DownlineStatusProvider>
          </ToastContextProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
